/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import PropTypes from 'prop-types';

import { CellTypes } from '../Guide/ProgramCell/CellTypes';

import './Highlight.scss';

interface HighlightProps {
    cellType?: string;
    isActive: boolean;
    isGhostHighlightActive: boolean;
    isHighlightVisible: boolean;
    isPastGuideMode: boolean;
}

const Highlight: FunctionComponent<HighlightProps> = ({
    cellType,
    isActive,
    isGhostHighlightActive,
    isHighlightVisible,
    isPastGuideMode,
}) => {
    return (
        <React.Fragment>
            {isActive ? (
                <div
                    className={`highlight${isGhostHighlightActive ? ' ghost' : ''}${
                        cellType === CellTypes.FUTURE_CONTINUOUS && !isPastGuideMode
                            ? ' hide-right-border'
                            : ''
                    }${isHighlightVisible ? '' : ' hidden'} 
                    ${
                        cellType === CellTypes.PAST_CONTINUOUS && isPastGuideMode
                            ? ' hide-left-border'
                            : ''
                    }`}
                    data-testid="guide-highlight"
                ></div>
            ) : null}
        </React.Fragment>
    );
};

Highlight.propTypes = {
    cellType: PropTypes.string,
    isActive: PropTypes.bool.isRequired,
    isGhostHighlightActive: PropTypes.bool.isRequired,
    isPastGuideMode: PropTypes.bool.isRequired,
};

export default Highlight;
